import { FormNumberComponent } from "./number/number.component";
import { FormTextComponent } from "./text/text.component";
import { FormTextAreaComponent } from "./textarea/textarea.component";
import { FormToggleComponent } from "./toggle/toggle.component";
import { UnknownComponent } from "./unknown/unknown.component";

export const CUSTOM_COMPONENT_DIRECTIVES = [
	UnknownComponent,
	FormTextComponent,
	FormTextAreaComponent,
	FormNumberComponent,
	FormToggleComponent,
];

export function customComponentFactory() {
	return new Map([
		["*", UnknownComponent],
		["number", FormNumberComponent],
		["text", FormTextComponent],
		["textarea", FormTextAreaComponent],
		["toggle", FormToggleComponent],
	]);
}
